import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import { endReplay } from "../../src/shell/endReplay";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { doImageShake, doTakePhoto, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8AnnCorruptionLibraryBefore } from "./V8";

const v8 = images.v8;

export const V8AnnCorruptionBeforeLibrary = async (): Promise<any> => {
    doTransition(images.v8.V8AnnCorruptionMCAfterDate_3);
    ann.talk(`Here we are.`);
    doWaitImageByTime(images.v8.V8AnnCorruptionMCAfterDate_0);
    ann.talk(`Hey! Look at that!`);
    if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
        doWaitImageByTime(images.v8.V8AnnCorruptionMCAfterDate_1);
        mc.talk(`I'm a bit occupied here...`);
        ann.talk(`Hehe, you got a package.`);
    } else {


    }
    mc.talk(`It must be Vanessa's.`);
    doWaitImageByTime(images.v8.V8AnnCorruptionMCAfterDate_2);
    ann.talk(`Oh, I'll bring it inside then.`);


    doTransition(images.v8.V8AnnCorruptionBeforeLibrary_1);
    ann.talk(`So why is Vanessa having packages delivered to your address?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_1);
    mc.talk(`We are about to find out.`);
    mc.talk(`Open it.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_1);
    ann.talk(`Are you sure?`);
    mc.talk(`I'm sure she wouldn't mind.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_1);
    ann.talk(`Alright! Hehe, let's see what's inside! I'm so curious.`);
    doWaitImageByTime(images.v8.V8AnnCorruptionBeforeLibrary_2);
    ann.talk(`Hmm...`);
    ann.talk(`What's that?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_3);
    mc.talk(`To be honest, I didn't expect anything less.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_4);
    mc.talk(`That's an anal vibrator.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_5);
    ann.talk(`A-Anal V-Vibrator?`);
    ann.talk(`Now I understand why she didn't have it delivered it to her place.`);
    ann.talk(`Her parents would kill her if they found out.`);

    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_6);
    ann.talk(`Oh, wait, there is another thing here.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_7);
    ann.talk(`Hmm...`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_8);
    empty.think(`*Click*`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_9);
    empty.think(`*Buzz...*`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_10);
    ann.talk(`It glows!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_9);
    ann.talk(`What's that about?`);

    mc.talk(`So you'll be able to find your anus...?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_11);
    ann.talk(`It's not like I can see it anyway!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_10);
    mc.talk(`It's not for you to find.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_9);
    ann.talk(`Oh.`);
    mc.talk(`Do you want to try it?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_10);
    ann.talk(`Me? But it's Vanessa's!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_9);
    mc.talk(`I bet she wouldn't mind.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_10);
    ann.talk(`Yeah... But...`);
    if (Question.globalAnswers.v7PhotoShootRoomStuckFingerInAnnAss) {
        ann.talk(`Well...`);
        ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_9);
        ann.talk(`I remember you touched me there.`);
        mc.talk(`And you liked it.`);
        ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_11);
        ann.talk(`Hehe.`);
        mc.talk(`So? What do you say?`);
    } else {
        ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_10);
        ann.talk(`Isn't it weird?`);
        ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_9);
        mc.talk(`It's not.`);
        mc.talk(`But it's up to you.`);
    }

    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_11);
    ann.talk(`I want to try it!`);
    ann.talk(`So... How do we do it?`);
    mc.talk(`Sit on the table.`);
    ann.talk(`Hehe, Ok!`);
    doWaitImageByTime(images.v8.V8AnnCorruptionBeforeLibrary_12);
    mc.talk(`Damn, you are so sexy in this outfit.`);
    ann.talk(`Hehe. This is so crazy!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_13);
    mc.talk(`First, we need to lube it up a bit.`);
    ann.talk(`Okie!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_14);
    mc.talk(`Just like that.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_15);
    mc.talk(`Just a bit more.`);
    mc.talk(`That's enough.`);

    mc.talk(`Now, turn around.`);
    mc.talk(`Let me just take these off.`);
    doWaitImageByTime(v8.Anim_V8AnnCorruptionBeforeLibraryInsertPlug.poster);
    mc.talk(`Now we just need...`);
    ImageClass.setAnimation(images.v8.Anim_V8AnnCorruptionBeforeLibraryInsertPlug, { loop: 0 });
    mc.talk(`To put it inside...`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_0);
    ann.talk(`Oh!!!`);
    ann.talk(`It's inside!`);
    mc.talk(`How does that feel?`);
    ann.talk(`Weird. But in a good way.`);


    ann.talk(`How does it look for you?`);
    mc.talk(`Hot as hell.`);
    doWaitImageByTime(images.v8.V8AnnCorruptionBeforeLibrary_16);
    ann.talk(`And with my panties back on? Is it visible?`);
    mc.talk(`Slightly.`);
    mc.talk(`And that makes it even sexier!`);
    doWaitImageByTime(images.v8.V8AnnCorruptionBeforeLibrary_17);
    ann.talk(`Hehe.`);


    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_18);
    mc.talk(`Now, let's see how this works.`);
    doImageShake(images.v8.V8AnnCorruptionBeforeLibrary_19);
    empty.think(`*Click*`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_20);
    ann.talk(`Oh my!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_21);
    ann.talk(`${mc.name}!`);

    mc.talk(`What? I'm just checking!`);
    doImageShake(images.v8.V8AnnCorruptionBeforeLibrary_19);
    empty.think(`*Click*`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_20);
    ann.talk(`Oh-h...!`);
    mc.talk(`Working as intended.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_21);
    ann.talk(`Hehe.`);



    return jump(V8AnnCorruptionBeforeLibrary_Photoshoot, "V8AnnCorruptionBeforeLibrary_Photoshoot");
};

export const V8AnnCorruptionBeforeLibrary_Photoshoot = async (): Promise<any> => {
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_13);
    mc.talk(`So, I was thinking.`);
    mc.talk(`Remember when you told me before that you want to build up your self-confidence?`);
    ann.talk(`I do.`);

    mc.talk(`So we're going to do another photo shoot right now.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_13.partials.V8AnnCorruptionBeforeLibrary_13_p);
    ann.talk(`With... This thing inside of me?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_13.partials.V8AnnCorruptionBeforeLibrary_13_p_2);
    mc.talk(`You need to learn to stay in control, ignore distractions and feel comfortable around the camera.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_13);
    ann.talk(`Hehe, but... Isn't it weird?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_13.partials.V8AnnCorruptionBeforeLibrary_13_p_2);
    mc.talk(`It's not, and you need to learn to ignore it.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_13);
    ann.talk(`Let's do that!`);

    mc.talk(`Let's start without the skirt.`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_22);
    ann.talk(`How's that?`);
    mc.talk(`Not bad, not bad.`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_22, { wait: true });
    mc.talk(`Maybe try to drop the thong and try to do a flirty pose.`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_23);
    ann.talk(`Like this?`);
    mc.talk(`Perfect!`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_23, { wait: true });

    mc.talk(`Now, let me see some of that sweet ass!`);
    ann.talk(`But I'm putting the thong back on!`);
    mc.talk(`Sure, for a couple of photos.`);

    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_24);
    ann.talk(`How's that?`);
    mc.talk(`You are so sexy!`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_24, { wait: true });
    ann.talk(`Hehe!`);
    ann.talk(`Is it glowing?`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_48);
    mc.talk(`It is.`);
    ann.talk(`I hope it's not weird!`);
    mc.talk(`It's hot you can barely see it.`);
    ann.talk(`Hehe, okie.`);

    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_25);
    ann.talk(`How do I look now? Is it too much?`);
    mc.talk(`I think you are getting the hang of it!`);
    mc.talk(`How does it feel for you?`);
    ann.talk(`I feel hot!`);
    mc.talk(`Exactly.`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_25, { wait: true });
    mc.talk(`Now I know which photo to post if I ever want to sell my guitar.`);
    ann.talk(`Hehe.`);


    // TODO: renders (talking - Ann sitting on floor near guitar (25))
    mc.talk(`Now let's try something that you've never done before.`);
    mc.talk(`I think it's time to lose that thong.`);
    ann.talk(`I feel confident enough to do it!`);



    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_29);
    mc.think(`Not long ago she was so shy taking off her bra in front of me...`);
    mc.think(`And now I'm taking photos of Ann's completely nude body.`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_29, { wait: true });
    mc.talk(`Amazing.`);

    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_26);
    mc.think(`I didn't even need to guide her for this pose, she's definitely feeling confident and comfortable.`);
    mc.talk(`Damn.`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_26, { wait: true });
    mc.talk(`I can't hold myself when you are lying like that.`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_27);
    ann.talk(`How about now?`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_27, { wait: true });
    mc.think(`Is she teasing me?`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_28);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_28, { wait: true });
    await mc.setQuestion(new Question({ text: `She definitely is!`, options: { think: true }, key: `v8AnnCorBeforeLibraryFuckHer` })
        .option({ title: `Fuck her`, key: true })
        .option({ title: `Don't fuck her`, key: false }));


    if (Question.globalAnswers.v8AnnCorBeforeLibraryFuckHer) {
        return jump(V8AnnCorruptionBeforeLibrary_Fuck, "V8AnnCorruptionBeforeLibrary_Fuck");

    } else {

    }
    return jump(V8AnnCorruptionBeforeLibrary_DontFuck, "V8AnnCorruptionBeforeLibrary_DontFuck");

};

export const V8AnnCorruptionBeforeLibrary_Fuck = async (): Promise<any> => {
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_28);
    mc.think(`I can't!`);
    mc.talk(`You asked for it.`);

    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_31);
    mc.talk(`Look what you did!`);
    ann.talk(`Hehe.`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_33);
    ann.talk(`*Lick*`);

    mc.think(`I might as well...`);
    mc.talk(`Look at me.`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_32);
    mc.think(`I might as well cherish the moment.`);
    mc.think(`She don't mind me filming her sucking my cock.`);
    mc.think(`Either that anal plug is making her extremely horny, or there is a side of her that I haven't seen before.`);

    mc.talk(`Smile for the camera.`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_30);
    mc.think(`Wow, who would have thought she would feel so comfortable?`);

    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_30, { wait: true });
    // TODO: make a render of her extending her arm 
    doWaitImageByTime(images.v8.V8AnnCorruptionBeforeLibrary_35);
    mc.think(`Ann grabbed my hand and put it around her neck...`);
    mc.think(`What the fuck? Does she want me to choke her?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_36);
    ann.talk(`${mc.name}... Yes...`);
    mc.think(`It really turns her on... Who am I to say no?`);
    // ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_37);
    doWaitImageByTime(images.v8.Anim_V8AnnCorruptionBeforeLibraryMiss.poster);
    ImageClass.setAnimation(images.v8.Anim_V8AnnCorruptionBeforeLibraryMiss);


    mc.think(`The harder I squeezed the more sweaty her body became.`);
    mc.think(`I kept fucking her for a few minutes... I could tell she was extremely turned on.`);
    ann.talk(`Ah...`);
    mc.think(`I couldn't help but think where this came from all of a sudden.`);
    mc.think(`Is it something she saw on the internet?`);
    if (Question.globalAnswers.v3KeepAnsweringChris) {
        mc.think(`Or is it something she is doing with Chris?`);

    } else {

    }
    mc.think(`${mc.name}! Snap out of it! Focus!`);

    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_39);
    mc.think(`So sweet Ann likes it rough...`);
    ann.talk(`Oh my god!`);
    mc.think(`Seeing that glowing anal plug sticking out of her ass is a real turn on.`);
    doWaitImageByTime(v8.Anim_V8AnnCorruptionBeforeLibraryDoggy.poster);
    ImageClass.setAnimation(images.v8.Anim_V8AnnCorruptionBeforeLibraryDoggy);
    mc.think(`By the sound of her moaning I know it feels amazing for her.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_41);
    mc.think(`I'm cumming!`);

    doImageShake(images.v8.V8AnnCorruptionBeforeLibrary_47);
    mc.talk(`Ahh!!!`);
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_34);
    ann.talk(`Hehe, are we done with the photos now?`);
    doTakePhoto();
    ImageClass.setImage(v8.V8AnnCorruptionBeforeLibrary_34, { wait: true });
    mc.talk(`Now we are.`);
    if (Question.globalAnswers.v8FuckedAngela) {
        mc.think(`Even though the circumstances couldn't be more different...`);
        mc.think(`I couldn't avoid the thought that I did something really similar with Angela...`);
    }
    doWaitImageByTime(v8.V8AnnCorruptionBeforeLibrary_43);
    ann.talk(`Wow... That was amazing.`);
    await endReplay(replayScenesList.v8annBeforeLibrarySex);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_44);
    mc.talk(`It really was.`);
    mc.talk(`But I must ask, where did that come from?`);

    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_43);
    ann.talk(`I've... Seen it in a movie.`);
    ann.talk(`It seemed rough but then I did some research online...`);
    ann.talk(`Girls said some interesting things about that so I had to try...`);
    ann.talk(`I'm glad you were on board!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_44);
    mc.talk(`Why wouldn't I be? It was extremely hot.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_43);
    ann.talk(`Hehe, I think so too.`);

    return jump(V8AnnCorruptionBeforeLibrary_2, "V8AnnCorruptionBeforeLibrary_2");
};
export const V8AnnCorruptionBeforeLibrary_DontFuck = async (): Promise<any> => {
    mc.think(`It's extremely hot but I'll hold myself back this time.`);
    return jump(V8AnnCorruptionBeforeLibrary_2, "V8AnnCorruptionBeforeLibrary_2");
};

export const V8AnnCorruptionBeforeLibrary_2 = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8AnnCorruptionBeforeLibrary_34.partials.V8AnnCorruptionBeforeLibrary_34_p_2, { putParent: true });
    ann.talk(`Even though it was a short session it really helped!`);
    ann.talk(`I'm sure it will help me feel more comfortable around the camera now.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_34);
    mc.talk(`You're welcome but we aren't done.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_34.partials.V8AnnCorruptionBeforeLibrary_34_p_2);
    ann.talk(`Really? What else have you got in mind?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_34);
    mc.talk(`Feeling comfortable around me is one thing. But doing it around strangers is another thing.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_34.partials.V8AnnCorruptionBeforeLibrary_34_p_2);
    ann.talk(`I feel like you have something in mind.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_34);
    mc.talk(`I do.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_43);
    ann.talk(`What is it? Tell me!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_44);
    mc.talk(`You'll see once we get there.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_45);
    ann.talk(`Oh my! I'm so curious!`);
    doWaitImageByTime(images.v8.V8AnnCorruptionBeforeLibrary_46);
    ann.talk(`Help met just get this thing out and we can go.`);
    mc.talk(`This stays in.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_44);
    mc.talk(`You wanted to learn how to stay focused right?`);
    mc.talk(`So that stays there.`);

    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_43);
    ann.talk(`Okay! I agree, let's go already I'm so curious!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionBeforeLibrary_44);
    mc.talk(`We'll have to do a small detour to your house to grab your glasses.`);

    return jump(V8AnnCorruptionLibraryBefore, "V8AnnCorruptionLibraryBefore");
};